// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YJ8-","content":"styles_content__ACEi8"};